import { LayoutProps } from '@volkswagen-onehub/components-core';
import React from 'react';
import { isLayerForm } from '../../helpers/form-helpers';
import { useBreakpoint } from '../../helpers/screen-helpers';

interface GridProps extends Omit<LayoutProps, 'rowGap'> {
	rowGap?: string;
}

export function Grid(props: GridProps) {
	const { children, appearance, allowOverflowingContent, rowGap } = props;

	const currentBreakpoint = useBreakpoint();

	// Eliminamos todos los breakpoints superiores a 960 si es un Layer
	const filteredAppearance =
		isLayerForm() && appearance
			? Object.entries(appearance)
					.filter(([key]) => Number(key) <= 960)
					.reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {} as typeof appearance)
			: appearance;

	// Calculamos el número de columnas a repetir según el breakpoint actual
	const getRepeatColumns = () => {
		if (!filteredAppearance) return 1;
		const breakpoints = Object.keys(filteredAppearance)
			.map(Number)
			.sort((a, b) => b - a);
		const targetBreakpoint = breakpoints.find((bp) => currentBreakpoint >= bp) || breakpoints[breakpoints.length - 1];
		return 24 / filteredAppearance[String(targetBreakpoint)][0].columns;
	};

	const repeatColumns = getRepeatColumns();

	return (
		<div
			style={{
				display: 'grid',
				rowGap: rowGap || '0',
				gridTemplateColumns: `repeat(${repeatColumns}, 1fr)`,
				overflow: allowOverflowingContent ? 'visible' : 'hidden',
			}}
		>
			{children}
		</div>
	);
}
